/**
 * contactConversion.ts - Utilities for converting between contact types
 *
 * Provides conversion functions between TestContact (from shared testing components)
 * and FlowContact (used for canvas visualization).
 *
 * Related:
 *   - types/contacts.ts - FlowContact type definition
 *   - shared/components/automation/testing/types.ts - TestContact type definition
 */

import type { TestContact } from '../../../../shared/components/automation/testing/types';
import type { FlowContact } from '../types/contacts';

/**
 * Converts a TestContact to a FlowContact for canvas visualization.
 */
function testContactToFlowContact(testContact: TestContact): FlowContact {
	const { contact, color, isSelected } = testContact;

	const tags: string[] = contact.tags || [];
	const keyFacts: string[] = contact.keyFacts || [];

	return {
		id: contact.id || '',
		firstName: contact.firstName || '',
		lastName: contact.lastName || '',
		profilePic: contact.profilePic || undefined,
		tags,
		keyFacts,
		color,
		isActive: isSelected,
	};
}

/**
 * Gets active (selected) FlowContacts from an array of TestContacts.
 *
 * @param testContacts - Array of TestContacts
 * @returns Array of FlowContacts that are selected/active
 */
export function getActiveFlowContacts(testContacts: TestContact[]): FlowContact[] {
	return testContacts.filter(tc => tc.isSelected).map(testContactToFlowContact);
}
